//@flow
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['entities'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

export const CreatePjpStateChart = {
    initial: 'outletSelection',
    states: {
        outletSelection: {
            on: {
                NEXT: 'riderSelection'
            }
        },
        riderSelection: {
            on: {
                NEXT: 'configurationSelection',
                PREV: 'outletSelection'
            }
        },
        configurationSelection: {
            on: {
                PREV: 'riderSelection'
            }
        }
    }
};
const PjpStepsIndex = {
    outletSelection: 1,
    riderSelection: 2,
    configurationSelection: 3
};

export const PjpStepsList = [
    {
        id: 'outletSelection',
        index: PjpStepsIndex.outletSelection,
        name: nsTranslate('entities:masterOutlet_plural')
    },
    {
        id: 'riderSelection',
        index: PjpStepsIndex.riderSelection,
        name: nsTranslate('entities:masterRider_plural')
    },
    {
        id: 'configurationSelection',
        index: PjpStepsIndex.configurationSelection,
        name: nsTranslate('translations:configuration')
    }
];

export default CreatePjpStateChart;
